import { render, staticRenderFns } from "./BanFileUpload.vue?vue&type=template&id=ab121e4a&"
import script from "./BanFileUpload.vue?vue&type=script&lang=js&"
export * from "./BanFileUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports